import React, { useState } from 'react';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqs = [
    {
      question: 'What services do you offer?',
      answer: 'We specialize in helping clients buy homes, refinance their existing mortgages, and access reverse mortgage options, providing personalized solutions for all your financial needs.'
    },
    {
      question: 'How do I get started with your services?',
      answer: 'Simply fill out our contact form, give us a call, or use our online application to start the process. Our team will guide you from there.'
    },
    {
      question: 'Why should I choose your company?',
      answer: 'We offer expert guidance, competitive rates, and a personalized approach tailored to your financial goals. Our clients consistently rate us highly for delivering excellent service.'
    },
    {
      question: 'How long does the mortgage process take?',
      answer: 'The timeline varies, but on average, the process takes 30-45 days from application to closing, depending on the type of mortgage and your financial profile.'
    },
    {
      question: 'What credit score do I need to qualify?',
      answer: 'Most loan programs require a credit score of 620 or higher, but we offer options for various credit situations and can help you explore what\'s best for you.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Have questions?<br />Find answer.</h2>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question-button"
                onClick={() => toggleFAQ(index)}
              >
                <span className="faq-question">{faq.question}</span>
                <svg 
                  className={`faq-icon ${openIndex === index ? 'open' : ''}`}
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    d="M18 15L12 9L6 15" 
                    stroke="#0578EC" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="faq-contact-card">
          <img 
            className="contact-avatar"
            src="https://api.builder.io/api/v1/image/assets/TEMP/1676ca8586c1553ae1668752c1e7d392f60bca4b?width=256" 
            alt="Contact representative" 
          />
          <div className="contact-info">
            <h3 className="contact-title">Still have a questions?</h3>
            <div className="contact-details">
              <div className="contact-detail-item">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_1_2134)">
                    <path d="M10.0003 4.99996V9.99996L13.3337 11.6666M18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6023 1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663C14.6027 1.66663 18.3337 5.39759 18.3337 9.99996Z" stroke="#0578EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_2134">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span>Mon - Fri, 9am to 7pm</span>
              </div>
              <div className="contact-detail-item">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5625 3.75H3.4375C2.57417 3.75 1.875 4.45 1.875 5.3125V14.6875C1.875 15.55 2.575 16.25 3.4375 16.25H16.5625C17.425 16.25 18.125 15.55 18.125 14.6875V5.3125C18.125 4.44917 17.425 3.75 16.5625 3.75Z" stroke="#0578EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4.375 6.25L10 10.625L15.625 6.25" stroke="#0578EC" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Valentinoloanofficer@gmail.com</span>
              </div>
              <div className="contact-detail-item">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.4999 14.5376C16.8894 13.9222 15.4108 13.0246 14.6928 12.6627C13.7582 12.1917 13.6811 12.154 12.9467 12.6996C12.4569 13.064 12.1311 13.3889 11.5576 13.2666C10.9832 13.1444 9.73762 12.4543 8.64631 11.3671C7.555 10.2791 6.82555 8.99658 6.70329 8.42549C6.58021 7.85358 6.91089 7.53111 7.27192 7.04043C7.78065 6.34872 7.74209 6.23303 7.3072 5.29844C6.96832 4.57145 6.04358 3.10598 5.42654 2.49796C4.76601 1.84564 4.76601 1.96133 4.34016 2.13775C3.99345 2.28373 3.66084 2.46116 3.34649 2.66781C2.73109 3.07644 2.38975 3.41614 2.15098 3.92651C1.91138 4.43688 1.80471 5.63322 3.03797 7.87409C4.27123 10.115 5.13689 11.2604 6.9273 13.0467C8.71934 14.833 10.0962 15.7939 12.1098 16.9229C14.6009 18.3178 15.556 18.0462 16.068 17.8075C16.58 17.5695 16.9214 17.2306 17.3316 16.6152C17.5386 16.3013 17.716 15.969 17.8617 15.6224C18.0389 15.199 18.1546 15.199 17.5007 14.5385L17.4999 14.5376Z" stroke="#0578EC" strokeWidth="1.4"/>
                </svg>
                <span>+1 (714) 655-1681</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
 